import { ifAuthenticated } from './guards'
const LocationsOverview = () =>
  import(
    /* webpackChunkName: "locations" */ '@/views/locations/LocationsOverview'
  )
const LocationsBookSport = () =>
  import(
    /* webpackChunkName: "locations" */ '@/views/locations/LocationsBookSport'
  )
const LocationsBookType = () =>
  import(
    /* webpackChunkName: "locations" */ '@/views/locations/LocationsBookType'
  )
// const LocationsBookDate = () =>
//   import(
//     /* webpackChunkName: "locations" */ '@/views/locations/LocationsBookDate'
//   )
const LocationPage = () =>
  import(/* webpackChunkName: "locations" */ '@/views/locations/LocationPage')
const LocationsBookConfirm = () =>
  import(
    /* webpackChunkName: "locations" */ '@/views/locations/LocationsBookConfirm'
  )
const LocationBookingToActivity = () =>
  import(
    /* webpackChunkName: "locations" */ '@/views/locations/LocationBookingToActivity'
  )

// The old booking URL (/locaties/:slug/book) now lands on the location page.
// The query stays: the payment return (?action=payment&pid=…) and the card
// purchase (origin=…/book) still point here.
export const redirectBookingToLocationPage = (to) => ({
  path: to.path.replace(/\/book\/?$/, ''),
  query: to.query
})

export default [
  {
    path: '/locations',
    alias: '/locaties',
    name: 'LocationsOverview',
    component: LocationsOverview
  },
  {
    path: '/locations/:location',
    alias: '/locaties/:location',
    name: 'LocationPage',
    component: LocationPage,
    meta: { keepScrollOnQueryChange: true }
  },
  {
    path: '/locations/book/sport',
    alias: '/locaties/book/sport',
    name: 'LocationsBookSport',
    component: LocationsBookSport,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/locations/book/type',
    alias: '/locaties/book/type',
    name: 'LocationsBookType',
    component: LocationsBookType,
    beforeEnter: ifAuthenticated
  },
  // two records, no alias: vue-router 3 does not redirect an aliased path cleanly
  {
    path: '/locations/:location/book',
    redirect: redirectBookingToLocationPage
  },
  {
    path: '/locaties/:location/book',
    redirect: redirectBookingToLocationPage
  },
  {
    path: '/locations/book/confirm',
    alias: '/locaties/book/confirm',
    name: 'LocationsBookConfirm',
    component: LocationsBookConfirm,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/locations/book/activity',
    alias: '/locaties/book/activity',
    name: 'LocationBookingToActivity',
    component: LocationBookingToActivity,
    beforeEnter: ifAuthenticated
  }
]
